<template>
	<footer
		class="footer"
		:style="cssVars"
	>
		<div class="upper container">

			<div
				class="footer_col one"
				data-aos="fade-right"
				data-aos-duration="750"
				data-aos-delay="0"
			>

				<a
					href="/"
					class="brand"
				><img
						:src="parsedGlobalSettings.footer.footer_logo ? parsedGlobalSettings.footer.footer_logo.url : this.logo"
						alt="Duco"
						height="50"
					/></a>

				<ul
					class='socials'
					v-if="parsedGlobalSettings.footer.social_channels"
				>
					<template v-for="(channel, index) in parsedGlobalSettings.footer.social_channels">
						<li
							:key="index"
							v-if="channel.url.url"
						>
							<a
								v-if="channel.url.url"
								:href="channel.url.url"
								:target="channel.url.target"
							><img
									v-if="channel.icon.url"
									:src="channel.icon.url"
									:alt="index"
								/></a>
						</li>
					</template>
				</ul>

			</div>

			<div
				class="footer_col two"
				data-aos="fade-right"
				data-aos-duration="750"
				data-aos-delay="100"
			>
				<ul>
					<li
						v-for="(menu_item, index) in parsedFooterMenu"
						:key="index"
					>
						<h4
							class='col-title'
							v-html="menu_item['title']"
						></h4>

						<ul v-if="menu_item['children']">
							<li
								v-for="(menu_item, index) in menu_item['children']"
								:key="index"
							><a
									:href="menu_item['url']"
									v-html="menu_item['title']"
									:target="menu_item['target']"
								></a></li>
						</ul>

					</li>
				</ul>

			</div>

			<div
				class="footer_col three"
				data-aos="fade-right"
				data-aos-duration="750"
				data-aos-delay="200"
			>
				<h5>Contact</h5>
				<div
					class="contact"
					v-html='parsedGlobalSettings.footer.contact_details'
				></div>

				<a
					v-if="parsedGlobalSettings.footer.privacy_policy"
					:href="parsedGlobalSettings.footer.privacy_policy['url']"
					v-html="parsedGlobalSettings.footer.privacy_policy['title']"
					:target="parsedGlobalSettings.footer.privacy_policy['target']"
				></a>

				<a
					class='built_by'
					v-if="parsedGlobalSettings.footer.built_by"
					:href="parsedGlobalSettings.footer.built_by['url']"
					v-html="parsedGlobalSettings.footer.built_by['title']"
					:target="parsedGlobalSettings.footer.built_by['target']"
				></a>
			</div>

		</div>

	</footer>
</template>

<script>
// import MenuItem from './MenuItem.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		logo: {},
		footer_menu: {},
		current_id: {
			type: Number,
			default: -1,
		},
		global_settings: {},
		asset_url: {},
		built_by: {},
		privacy_policy: {},
	},

	computed: {
		parsedGlobalSettings() {
			if (this.global_settings) {
				return JSON.parse(this.global_settings);
			} else {
				return null;
			}
		},

		parsedFooterMenu() {
			if (this.footer_menu) {
				return JSON.parse(this.footer_menu);
			} else {
				return null;
			}
		},

		getTheYear() {
			var d = new Date();
			var n = d.getFullYear();
			return n;
		},

		cssVars() {
			return {
				'--spacer': '24px',
				'--spacer-mobile': '16px',
				'--gutter-mobile': '16px',
				'--gutter-tablet-desktop': '24px',
				'--body-font-size': '16px/22px',
				'--max-width': '1680px',
			};
		},
	},

	watch: {},

	methods: {
		getFullUrl(arg) {
			let assetUrl = this.asset_url;
			return assetUrl + arg + '.svg';
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {
		// MenuItem,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.footer {
	padding: 0;
	background: var(--black);
	border-top: 1px solid var(--grey);
	overflow: hidden;

	@media (max-width: $mobile-xl) {
		padding: 32px 0;
	}

	.upper {
		@media (max-width: $mobile-xl) {
			row-gap: 40px;
			margin-bottom: 0;
		}

		&.container {
			column-gap: 40px;
		}

		.footer_col {
			grid-column: span 6;
			color: var(--white);
			border-right: 1px solid var(--grey);
			padding: 100px 0;

			&:last-of-type {
				border-right: unset;

				@media (max-width: $mobile-xl) {
					border-bottom: unset;
				}
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
				padding: 0 var(--gutter-mobile);
				border-right: unset;
				border-bottom: 1px solid var(--grey);
			}

			.brand {
				width: 180px;
				display: flex;
				margin-bottom: 50px;

				@media (max-width: $mobile-xl) {
					justify-content: flex-start;
					margin-bottom: 24px;
				}

				img {
					width: 100%;
					height: 100%;
				}
			}

			.socials {
				list-style: none;
				padding: 0;
				margin: 0;
				display: flex;
				flex-direction: row;

				li {
					a {
						img {
							width: 50px;
							height: 50px;
						}
					}
				}
			}

			&::v-deep {
				h4 {
					margin: 0 0 24px;
					color: var(--white);

					&.col-title {
						text-transform: capitalize;
						font-size: 20px;
						font-weight: normal;
						margin: 0;
						color: var(--duco-blue);
					}

					@media (max-width: $mobile-xl) {
						font: normal normal bold 20px/24px var(--primary-font-family);
					}
				}

				h3 {
					color: var(--white);
					font: normal normal 600 var(--body-font-size)
						var(--primary-font-family);
					text-transform: uppercase;
					margin: 24px 0 8px;

					@media (max-width: $mobile-xl) {
						margin: 16px 0 0;
					}

					&:first-of-type {
						margin: 0 0 8px;

						@media (max-width: $mobile-xl) {
							margin: 0 0 0;
						}
					}
				}

				p {
					font: normal normal normal 14px/20px var(--primary-font-family);
					margin: 0;
					margin: 0 0 16px;
				}

				a {
					color: var(--white);
					font: normal normal normal 14px/20px var(--primary-font-family);
					text-decoration: none;

					&:hover {
						text-decoration: underline;
					}
				}

				h5 {
					margin: 0;
				}
			}

			&.one {
				grid-column: span 4;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					padding: 0 var(--gutter-mobile) var(--gutter-mobile);
					border-right: unset;
					border-bottom: 1px solid var(--grey);
					display: flex;
					flex-wrap: wrap;
					flex-direction: column;
					align-items: center;
				}
			}

			&.two {
				grid-column: span 3;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					padding: 0 var(--gutter-mobile);
					border-right: unset;
					border-bottom: 1px solid var(--grey);
				}

				> ul {
					list-style: none;
					padding: 0;

					> li {
						margin-bottom: 20px;

						a {
							color: var(--duco-blue);
							font-size: 20px;
						}

						ul {
							list-style: none;
							padding: 0;
							margin-top: 8px;

							li {
								a {
									color: var(--white);
									font-size: 14px;
								}
							}
						}
					}
				}
			}

			&.three {
				grid-column: span 5;
				display: flex;
				flex-direction: column;
				gap: 16px;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					padding: 0 var(--gutter-mobile);
					border-right: unset;
				}

				h5 {
					color: var(--duco-blue);
					font-size: 20px;

					font-weight: normal;
					text-transform: capitalize;
				}

				.contact {
					&::v-deep {
						a {
							line-height: 20px;
						}

						p {
							&:last-of-type {
								margin-bottom: 0;
							}
						}
					}
				}

				.built_by {
					color: var(--grey);
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteFooter.vue